/**
 * @description
 * Objeto userprofile
 */

export class Userprofile {
    public id:number;
    public identifier:string;
    public lang:string = null;
  
    constructor() {}
  
}